import { breakpoints, theme } from '@notino/react-styleguide';

import ProgressBar from '@components/ProgressBar';
import { styled } from '@linaria/react';

export const AttributesReviews = styled.div`
  margin-top: 1.2rem;
  border-top: 1px solid ${theme.color.border.divider};
  padding: 1.5rem 0;

  @media (min-width: ${breakpoints.md}) {
    margin-top: 2.5rem;
    padding: 0;
    border: none;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 3rem;
  }
`;

export const ParamProgressWrapper = styled.div`
  width: 50%;
  display: flex;
  gap: 0.75rem;
  align-items: center;
`;

export const StyledProgressBar = styled(ProgressBar)`
  flex: 1;
`;

export const ParamValue = styled.div`
  ${theme.typography.labelRegular400};
  width: 50%;
  color: ${theme.color.text.secondary};
`;
